import React, {useEffect, useState} from "react";
import axios from "axios";
import Swal from "sweetalert2";
import {Button, Card, Col, Form, Modal, Row} from "react-bootstrap";
import ERPDataGrid from "../ERPDataGrid";
import "../ERPTheme.css";
import {baseUrl, ipAddress, userName} from "../Univ";
const AIModel = () => {
    const [models, setModels] = useState([]);
    const [loading, setLoading] = useState(false);
    const [show, setShow] = useState(false);
    const [editMode, setEditMode] = useState(false);
    const [modelId, setModelId] = useState(null);
    const [providerList, setProviderList] = useState([]);
    const initialState = {
    provider: "",
    model_name: "",
    model_identifier: "",
    model_type: "",
    version: "",
    temperature: 0.70,
    max_tokens: 4096,
    supports_chat: true,
    supports_image: false,
    supports_audio: false,
    supports_document: false,
    supports_prediction: false,
    is_active: true,
    description: "",
    addedby: userName,
    ip_address: ipAddress
};
    const [formData, setFormData] = useState(initialState);
    // ===============================
    // LOAD DATA
    // ===============================
    const loadModels = async () => {
        try {
            setLoading(true);
            const res = await axios.get(baseUrl + "ai-model/");
            setModels(res.data);
        } catch (error) {
            Swal.fire("Error", "Unable to load AI Models", "error");
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        loadModels();
        getProviders();
    }, []);
    // ===============================
    // INPUT CHANGE
    // ===============================
    const handleChange = (e) => {
        const {name, value, type, checked} = e.target;
        setFormData({
            ...formData, [name]: type === "checkbox" ? checked : value
        });
    };
    // ===============================
    // SAVE
    // ===============================
    const saveModel = async () => {
        try {
            if (editMode) {
                await axios.put(baseUrl + `ai-model/${modelId}/`, formData);
            } else {
                await axios.post(baseUrl + "ai-model/", formData);
            }
            Swal.fire("Success", "AI Model Saved Successfully", "success");
            setShow(false);
            resetForm();
            loadModels();
        } catch (error) {
            Swal.fire("Error", "Unable to save AI Model", "error");
        }
    };
    // ===============================
    // EDIT
    // ===============================
    const editModel = (row) => {
    setEditMode(true);
    setModelId(row.id);

    setFormData({
        provider: row.provider?.id || "",
        model_name: row.model_name || "",
        model_identifier: row.model_identifier || "",
        model_type: row.model_type || "",
        version: row.version || "",
        temperature: row.temperature || 0.70,
        max_tokens: row.max_tokens || 4096,
        supports_chat: row.supports_chat,
        supports_image: row.supports_image,
        supports_audio: row.supports_audio,
        supports_document: row.supports_document,
        supports_prediction: row.supports_prediction,
        is_active: row.is_active,
        description: row.description || "",
        addedby: userName,
        ip_address: ipAddress
    });

    setShow(true);
};
    // ===============================
    // DELETE
    // ===============================
    const deleteModel = (id) => {
        Swal.fire({
            title: "Are you sure?",
            text: "Delete AI Model?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Delete"
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    await axios.delete(baseUrl + `delete-ai-model/${id}/`);
                    Swal.fire("Deleted", "AI Model Deleted", "success");
                    loadModels();
                } catch (error) {
                    Swal.fire("Error", "Delete Failed", "error");
                }
            }
        });
    };
    // ===============================
    // RESET
    // ===============================
    const resetForm = () => {
        setFormData(initialState);
        setEditMode(false);
        setModelId(null);
    };
    const getProviders = () => {
    axios
        .get(baseUrl + "ai-provider/")
        .then((res) => setProviderList(res.data))
        .catch((err) => console.log(err));
};
    const columns = [
    {
        field: "id",
        headerName: "ID",
        width: 80
    },
    {
        field: "provider",
        headerName: "Provider",
        width: 150,
        renderCell: (params) => params.row.provider?.provider_name || ""
    },
    {
        field: "model_name",
        headerName: "Model Name",
        flex: 1.2
    },
    {
        field: "model_identifier",
        headerName: "Identifier",
        flex: 1.3
    },
    {
        field: "model_type",
        headerName: "Type",
        width: 140
    },
    {
        field: "version",
        headerName: "Version",
        width: 100
    },
    {
        field: "temperature",
        headerName: "Temp",
        width: 90
    },
    {
        field: "max_tokens",
        headerName: "Max Tokens",
        width: 120
    },
    {
        field: "supports_chat",
        headerName: "Chat",
        width: 80,
        renderCell: (params) => (params.value ? "✔" : "✖")
    },
    {
        field: "supports_image",
        headerName: "Image",
        width: 80,
        renderCell: (params) => (params.value ? "✔" : "✖")
    },
    {
        field: "supports_audio",
        headerName: "Audio",
        width: 80,
        renderCell: (params) => (params.value ? "✔" : "✖")
    },
    {
        field: "supports_document",
        headerName: "Document",
        width: 100,
        renderCell: (params) => (params.value ? "✔" : "✖")
    },
    {
        field: "supports_prediction",
        headerName: "Prediction",
        width: 110,
        renderCell: (params) => (params.value ? "✔" : "✖")
    },
    {
        field: "is_active",
        headerName: "Status",
        width: 100,
        renderCell: (params) => (params.value ? "Active" : "Inactive")
    },
    {
        field: "action",
        headerName: "Action",
        width: 180,
        renderCell: (params) => (
            <>
                <Button
                    size="sm"
                    variant="warning"
                    className="me-2"
                    onClick={() => editModel(params.row)}
                >
                    Edit
                </Button>

                <Button
                    size="sm"
                    variant="danger"
                    onClick={() => deleteModel(params.row.id)}
                >
                    Delete
                </Button>
            </>
        )
    }
];
    return (<>

            <Card className="shadow mb-3">


                <Card.Header>

                    <Row>

                        <Col>

                            <h5>
                                AI Model Master
                            </h5>

                        </Col>


                        <Col className="text-end">


                            <Button

                                variant="primary"

                                onClick={() => {
                                    resetForm();
                                    setShow(true);
                                }}

                            >

                                + Add AI Model

                            </Button>


                        </Col>


                    </Row>


                </Card.Header>


                <Card.Body>


                    <div
                        style={{
                            height: 500, width: "100%"
                        }}
                    >


                        <ERPDataGrid

                            rows={models}

                            columns={columns}

                            loading={loading}


                        />


                    </div>


                </Card.Body>


            </Card>


            <Modal

                show={show}

                onHide={() => setShow(false)}

                size="lg"

            >


                <Modal.Header closeButton>

                    <Modal.Title>

                        {editMode ? "Edit AI Model" : "Add AI Model"}

                    </Modal.Title>

                </Modal.Header>


                <Modal.Body>


                    <Form>

    <Row>

        <Col md={6}>
            <Form.Group>
                <Form.Label>Provider</Form.Label>
                <Form.Select
                    name="provider"
                    value={formData.provider}
                    onChange={handleChange}
                >
                    <option value="">Select Provider</option>
                    {providerList.map((item) => (
                        <option key={item.id} value={item.id}>
                            {item.provider_name}
                        </option>
                    ))}
                </Form.Select>
            </Form.Group>
        </Col>

        <Col md={6}>
            <Form.Group>
                <Form.Label>Model Name</Form.Label>
                <Form.Control
                    name="model_name"
                    value={formData.model_name}
                    onChange={handleChange}
                />
            </Form.Group>
        </Col>

    </Row>

    <Row className="mt-3">

        <Col md={6}>
            <Form.Group>
                <Form.Label>Model Identifier</Form.Label>
                <Form.Control
                    name="model_identifier"
                    value={formData.model_identifier}
                    onChange={handleChange}
                />
            </Form.Group>
        </Col>

        <Col md={6}>
            <Form.Group>
                <Form.Label>Model Type</Form.Label>
                <Form.Select
                    name="model_type"
                    value={formData.model_type}
                    onChange={handleChange}
                >
                    <option value="">Select Type</option>
                    <option value="Chat">Chat</option>
                    <option value="Multimodal">Multimodal</option>
                    <option value="Reasoning">Reasoning</option>
                    <option value="Local LLM">Local LLM</option>
                    <option value="Vision">Vision</option>
                    <option value="Speech">Speech</option>
                    <option value="Embedding">Embedding</option>
                </Form.Select>
            </Form.Group>
        </Col>

    </Row>

    <Row className="mt-3">

        <Col md={4}>
            <Form.Group>
                <Form.Label>Version</Form.Label>
                <Form.Control
                    name="version"
                    value={formData.version}
                    onChange={handleChange}
                />
            </Form.Group>
        </Col>

        <Col md={4}>
            <Form.Group>
                <Form.Label>Temperature</Form.Label>
                <Form.Control
                    type="number"
                    step="0.01"
                    name="temperature"
                    value={formData.temperature}
                    onChange={handleChange}
                />
            </Form.Group>
        </Col>

        <Col md={4}>
            <Form.Group>
                <Form.Label>Max Tokens</Form.Label>
                <Form.Control
                    type="number"
                    name="max_tokens"
                    value={formData.max_tokens}
                    onChange={handleChange}
                />
            </Form.Group>
        </Col>

    </Row>

    <hr />

    <Row>

        <Col md={4}>
            <Form.Check
                type="checkbox"
                label="Supports Chat"
                name="supports_chat"
                checked={formData.supports_chat}
                onChange={handleChange}
            />
        </Col>

        <Col md={4}>
            <Form.Check
                type="checkbox"
                label="Supports Image"
                name="supports_image"
                checked={formData.supports_image}
                onChange={handleChange}
            />
        </Col>

        <Col md={4}>
            <Form.Check
                type="checkbox"
                label="Supports Audio"
                name="supports_audio"
                checked={formData.supports_audio}
                onChange={handleChange}
            />
        </Col>

    </Row>

    <Row className="mt-2">

        <Col md={4}>
            <Form.Check
                type="checkbox"
                label="Supports Document"
                name="supports_document"
                checked={formData.supports_document}
                onChange={handleChange}
            />
        </Col>

        <Col md={4}>
            <Form.Check
                type="checkbox"
                label="Supports Prediction"
                name="supports_prediction"
                checked={formData.supports_prediction}
                onChange={handleChange}
            />
        </Col>

        <Col md={4}>
            <Form.Check
                type="checkbox"
                label="Active"
                name="is_active"
                checked={formData.is_active}
                onChange={handleChange}
            />
        </Col>

    </Row>

    <Form.Group className="mt-3">
        <Form.Label>Description</Form.Label>
        <Form.Control
            as="textarea"
            rows={4}
            name="description"
            value={formData.description}
            onChange={handleChange}
        />
    </Form.Group>

</Form>


                </Modal.Body>


                <Modal.Footer>


                    <Button

                        variant="secondary"

                        onClick={() => setShow(false)}

                    >

                        Close

                    </Button>


                    <Button

                        variant="success"

                        onClick={saveModel}

                    >

                        Save

                    </Button>


                </Modal.Footer>


            </Modal>


        </>);
};
export default AIModel;